import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ArrowLeft: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path fill='none' d='M0 0h24v24H0z' />
      <path
        fill='currentColor'
        d='M21 11.25H5.81l4.72-4.72-1.06-1.06L2.94 12l6.53 6.53 1.06-1.06-4.72-4.72H21v-1.5z'
      />
    </svg>
  </i>
);

ArrowLeft.displayName = 'ArrowLeft';
export default ArrowLeft;
export { styles };
